<template>
  <div class="survey-cake-page" :class="{ 'pdf-mode': isPDF }">
    <div class="name GenSenRounded">{{ truncatedName }}</div>
    <img src="@/assets/survey-cake/start-page.jpg" class="start-page" />
  </div>
</template>

<script>
export default {
  name: "StartPage",
  props: {
    name: {
      type: String | null,
      required: true,
    },
    isPDF: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    truncatedName() {
      if (!this.name) {
        return "";
      }
      const maxWidth = 18;
      let currentWidth = 0;
      let result = "";

      for (let i = 0; i < this.name.length; i++) {
        const char = this.name[i];
        let charWidth;

        if (/[\u4e00-\u9fff]/.test(char)) {
          // 中文字符
          charWidth = 2;
        } else if (/[A-Z]/.test(char)) {
          // 大寫英文
          charWidth = 1.63;
        } else if (/[a-z]/.test(char)) {
          // 小寫英文
          charWidth = 1.28;
        } else if (/[0-9]/.test(char)) {
          // 數字
          charWidth = 1.28;
        } else {
          // 其他符號
          charWidth = 2;
        }

        if (currentWidth + charWidth > maxWidth) {
          result += "...";
          break;
        }

        result += char;
        currentWidth += charWidth;
      }

      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.survey-cake-page {
  width: 100vw;
  height: calc((3508 / 2480) * 100vw);
  background-color: #fae4cb;
  position: relative;
  .name {
    font-size: 7vw;
    font-weight: 700;
    width: 70%;
    position: absolute;
    text-align: center;
    bottom: 18%;
    left: 50%;
    transform: translateX(-50%) rotate(-3.5deg);
    color: #eb6165;
    text-shadow: -0.35vw -0.35vw 0 #fff, 0.35vw -0.35vw 0 #fff,
      -0.35vw 0.35vw 0 #fff, 0.35vw 0.35vw 0 #fff, -0.35vw 0 0 #fff,
      0.35vw 0 0 #fff, 0 -0.35vw 0 #fff, 0 0.35vw 0 #fff;
  }
  .start-page {
    width: 100%;
    vertical-align: middle;
  }
}
.survey-cake-page.pdf-mode {
  width: 2480px;
  height: 3508px;
  .name {
    bottom: 20%;
    font-size: 166px;
    text-shadow: -8px -8px 0 #fff, 8px -8px 0 #fff, -8px 8px 0 #fff,
      8px 8px 0 #fff, -8px 0 0 #fff, 8px 0 0 #fff, 0 -8px 0 #fff, 0 8px 0 #fff;
  }
}
</style>
